module.exports = __webpack_public_path__ + "assets/img/screen-2.995d6d03.png";